import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Chip } from "@nextui-org/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShield } from "@fortawesome/free-solid-svg-icons";
import EditUIFormBuilder from "./EditUIFormBuilder";
import EditJsonFormBuilder from "./EditJsonFormBuilder";
import EditAIFormBuilder from "./EditAIFormBuilder";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";
import { getDataWithFilterUrl, UpdateOneData } from "../../controllers/APIController";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const EditFormBuilder = () => {
  const { _id } = useParams();
  const [metricInfo, setMetricInfo] = useState(null);
  const [originId, setOriginId] = useState(null);
  const [activeTab, setActiveTab] = useState("Form Builder");
  const clientQuery= useQueryClient()

  const tabs = [
    {
      id: "Form Builder",
      label: "Form Builder",
      content: <EditUIFormBuilder />,
    },
    {
      id: "JSON Builder",
      label: "JSON Builder",
      content: <EditJsonFormBuilder />,
    },
  ];

  const resetOriginHandler = async () => {
    const filteredUrl = `filters[id][$eqi]=${originId}`;
    const response = await getDataWithFilterUrl("metrics", filteredUrl);
    const originMetricInfo = response?.data[0]?.attributes;

    const data = {
      ...originMetricInfo,
      originId: originId,
    };

    const result = await UpdateOneData("metrics", metricInfo?.id, data);
clientQuery.invalidateQueries({ queryKey: ["metrics", filteredUrl] });
    // setRenderPage((pre) => !pre);

    window.location.reload();
  };
    const filteredUrl = `filters[id][$eqi]=${_id}`;

  const { data: metricData } = useQuery({
    queryKey: ["metrics", filteredUrl],
    queryFn: () => getDataWithFilterUrl("metrics", filteredUrl),
  });
  
  console.log("metricData", metricData  );
useEffect(() => {
  if(metricData && metricData?.data){

    setMetricInfo(metricData?.data[0]);
    setOriginId(metricData?.data[0]?.attributes?.originId);
  }
}, [metricData]);

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Header */}
      <div className="bg-white border-b border-neutral-100 px-8 py-8 shadow-sm">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-semibold text-neutral-900">Edit a metric </h1>
              <p className="text-base text-neutral-600 mt-2">Edit a metric and build that would support your ESG Reporting</p>
            </div>
            <div className="flex items-center gap-3">
              <Chip color="success" variant="flat" size="md">
                <FontAwesomeIcon icon={faShield} className="mr-2 text-sm" />
                Secure
              </Chip>
            </div>
          </div>
        </div>
      </div>

      <BreadCrumbsPage>
        <div className="max-w-7xl mx-auto px-8 py-8">
          <div className="bg-white rounded-lg border border-neutral-200 shadow-sm overflow-hidden">
            {/* Description Header */}
            <div className="px-8 py-4 border-b border-neutral-200 bg-gradient-to-r from-neutral-50 to-white">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-xl font-semibold text-neutral-900 mb-3">Metric Configuration</h2>
                  <p className="text-base text-neutral-600 leading-relaxed">Choose your preferred method to edit the metric</p>
                </div>
                {originId && (
                  <Button
                    size="sm"
                    onClick={resetOriginHandler}
                    variant="ghost"
                    className="text-red-600 hover:text-red-700 hover:bg-red-50 px-4"
                  >
                    Reset to default
                  </Button>
                )}
              </div>
            </div>
            
            {/* Modern Segmented Button Tabs */}
            <div className="p-8">
              <div className="space-y-6">
                {/* Builder Options Section */}
                <div>
                  {/* <h3 className="text-lg font-semibold text-neutral-900 mb-4">Builder Options</h3>
                  <p className="text-sm text-neutral-600 mb-6">Select your preferred editing method</p>
                   */}
                  {/* Segmented Button Group */}
                  <div className="flex gap-2 p-1 bg-neutral-100 rounded-lg w-fit">
                    {tabs.map((tab) => (
                      <Button
                        key={tab.id}
                        variant={activeTab === tab.id ? "solid" : "light"}
                        color={activeTab === tab.id ? "primary" : "default"}
                        className={`px-6 py-3 font-medium transition-all duration-200 ${
                          activeTab === tab.id
                            ? "bg-primary-600 text-white shadow-md"
                            : "text-neutral-600 hover:text-neutral-900 hover:bg-neutral-200"
                        }`}
                        onClick={() => setActiveTab(tab.id)}
                      >
                        {tab.label}
                      </Button>
                    ))}
                  </div>
                </div>

                {/* Tab Content */}
                <div className="mt-8">
                  {tabs.find(tab => tab.id === activeTab)?.content}
                </div>
              </div>
            </div>
          </div>
        </div>
      </BreadCrumbsPage>
    </div>
  );
};

export default EditFormBuilder;
